import { Text } from '@heathmont/moon-core';
import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  title?: string;
  subtitle?: string;
  headerType?: 'h1' | 'h2' | 'p';
};

const BlogHeader: FC<Props> = ({
  title = 'blog.heading1',
  subtitle,
  headerType = 'h1',
}) => {
  const { siteConfig } = useSite();
  return (
    <div className="grid gap-2">
      <Text as={headerType} size={24} isBold>
        <Translate id={title} values={{ siteName: siteConfig.name }} />
      </Text>
      {!!subtitle && (
        <Text as="p">
          <Translate id={subtitle} />
        </Text>
      )}
    </div>
  );
};

export default BlogHeader;
